export default __webpack_public_path__ + "static/media/poi_marker_multi.ccb5927f.svg";